module.exports = __webpack_public_path__ + "img/logo.a15680f9.jpg";